var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropzone",class:['media-dropzone', _vm.isDragging || _vm.isDraggingOver ? 'media-dropzone--visible' : ''],on:{"dragenter":_vm.handleComponentDragEnter,"dragover":_vm.handleComponentDragOver,"dragleave":_vm.handleComponentDragLeave}})
}
var staticRenderFns = []

export { render, staticRenderFns }